import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function ReportsView({ clientId }) {
  const [ratings, setRatings] = useState([]);
  const [reports, setReports] = useState([]);
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [r, b, c] = await Promise.all([
          api.get(`/clients/${clientId}/ratings`).catch(() => ({ data: [] })),
          api.get(`/clients/${clientId}/biweekly-reports`).catch(() => ({ data: [] })),
          api.get(`/clients/${clientId}`),
        ]);
        setRatings(r.data || []);
        setReports(b.data || []);
        setClient(c.data);
      } finally { setLoading(false); }
    })();
  }, [clientId]);

  if (loading) return <div className="text-zinc-600 text-[12px]">Loading…</div>;
  const dropdowns = client?.happiness_form?.dropdowns || [];

  return (
    <div className="space-y-6" data-testid="reports-view">
      <div className="tt-card p-5">
        <div className="t-eyebrow mb-4">Weekly happiness — {ratings.length} submission{ratings.length !== 1 ? "s" : ""}</div>
        {ratings.length === 0 ? (
          <div className="text-zinc-600 text-[12px]">No happiness submissions yet.</div>
        ) : (
          <ul className="divide-y divide-zinc-900">
            {ratings.map((r) => {
              const cls = r.rating >= 8 ? "score-good" : r.rating >= 7 ? "score-okay" : "score-bad";
              return (
                <li key={r.id} className="py-3 first:pt-0 last:pb-0">
                  <div className="flex items-start gap-3">
                    {r.rating > 0 && <span className={`px-2 py-1 rounded text-[12px] font-mono shrink-0 ${cls}`}>{r.rating}/10</span>}
                    <div className="flex-1 min-w-0">
                      <div className="text-[10px] text-zinc-500 font-mono uppercase tracking-wider">
                        {new Date(r.created_at).toLocaleString()} · {r.user_name}
                        <span className="ml-2">week of {r.week_start}</span>
                      </div>
                      {r.note && <div className="text-[13px] text-zinc-200 mt-1 leading-relaxed">"{r.note}"</div>}
                      {dropdowns.length > 0 && r.custom_answers && (
                        <div className="mt-2 flex flex-wrap gap-1.5">
                          {dropdowns.map((d) => {
                            const v = r.custom_answers[d.id];
                            if (!v) return null;
                            return (
                              <span key={d.id} className="px-1.5 py-0.5 rounded text-[10px] bg-zinc-900 border border-zinc-800 text-zinc-300">
                                <span className="text-zinc-600 mr-1">{d.label}:</span>{v}
                              </span>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <div className="tt-card p-5">
        <div className="t-eyebrow mb-4">Biweekly engagement reports — {reports.length}</div>
        {reports.length === 0 ? (
          <div className="text-zinc-600 text-[12px]">No biweekly reports yet.</div>
        ) : (
          <ul className="space-y-3">
            {reports.map((r) => (
              <li key={r.id} className="border-l border-zinc-800 pl-3.5">
                <div className="flex items-baseline gap-2">
                  <span className="font-display text-[18px] font-semibold">{r.rating}<span className="text-zinc-600 text-[12px]">/10</span></span>
                  <span className="text-[10px] text-zinc-600 font-mono uppercase tracking-wider">{new Date(r.created_at).toLocaleDateString()} · {r.user_name}</span>
                </div>
                <p className="text-[13px] text-zinc-300 mt-1 leading-relaxed">{r.text}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
